import { http } from '~/src/services/requests';
import qs from 'qs';

function authService() {
  return {
    searchMatter: (orgFprint, { fields = [], ...params } = {}) => {
      const parse = true;
      return http.innerSendAuthenticated(
        {
          relativePath: `/clients/api/v2/org/${orgFprint}/clio/matters/?${qs.stringify(
            {
              fields: fields.join(','),
              ...params,
            },
          )}`,
          method: 'GET',
        },
        parse,
      );
    },
    clioIntegrationData: (orgFprint) => {
      const parse = true;
      if (orgFprint === undefined) {
        console.error('clioIntegrationData called with undefined orgFprint');
        return;
      }
      return http.innerSendAuthenticated(
        {
          relativePath: `/clients/api/v1/org/${orgFprint}/clio/authorize/`,
          method: 'GET',
        },
        parse,
      );
    },
    deauthenticate: (orgFprint) => {
      const parse = false;
      if (orgFprint === undefined) {
        console.error('deauthenticate called with undefined orgFprint');
      }
      return http.innerSendAuthenticated(
        {
          relativePath: `/clients/api/v1/org/${orgFprint}/clio/authorize/`,
          method: 'DELETE',
        },
        parse,
      );
    },
    authenticate: (orgFprint, code) => {
      const parse = true;
      return http.innerSendAuthenticated(
        {
          relativePath: `/clients/api/v1/org/${orgFprint}/clio/auth-pro/`,
          method: 'POST',
          body: {
            code,
          },
        },
        parse,
      );
    },
    sync: (orgFprint) => {
      const parse = true;
      return http.innerSendAuthenticated(
        {
          relativePath: `/clients/api/v1/org/${orgFprint}/clio/sync/`,
          method: 'POST',
          headers: {
            Timezone: (-new Date().getTimezoneOffset()).toString(),
          },
        },
        parse,
      );
    },
    getWorkTemplateMigrationOverview: (orgFprint, recheck, copyJobId) => {
      const parse = true;
      const params = new URLSearchParams();
      if (recheck) {
        params.set('recheck', '1');
      }
      if (copyJobId) {
        params.set('copy_job', String(copyJobId));
      }
      const query = params.toString();
      return http.innerSendAuthenticated(
        {
          relativePath: `/clients/api/v1/org/${orgFprint}/clio/work_template_migration/overview/${
            query ? `?${query}` : ''
          }`,
          method: 'GET',
        },
        parse,
      );
    },
    startWorkTemplateMigration: (orgFprint, templateIds, notifyByEmail) => {
      const parse = true;
      return http.innerSendAuthenticated(
        {
          relativePath: `/clients/api/v1/org/${orgFprint}/clio/work_template_migration/`,
          method: 'POST',
          body: { template_ids: templateIds, notify_by_email: notifyByEmail },
        },
        parse,
      );
    },
    cancelWorkTemplateMigration: (orgFprint, templateIds) => {
      const parse = true;
      return http.innerSendAuthenticated(
        {
          relativePath: `/clients/api/v1/org/${orgFprint}/clio/work_template_migration/cancel/`,
          method: 'POST',
          // No body cancels the whole copy; an empty object isn't encoded and would be sent as
          // "[object Object]".
          ...(templateIds && { body: { template_ids: templateIds } }),
        },
        parse,
      );
    },
    matterSync: (orgFprint, matterId, location) => {
      const parse = true;
      return http.innerSendAuthenticated(
        {
          relativePath: `/clients/api/v1/org/${orgFprint}/clio/sync/matter/`,
          method: 'POST',
          headers: {
            Timezone: (-new Date().getTimezoneOffset()).toString(),
          },
          body: {
            external_id: matterId,
            ...(location && { location }),
          },
        },
        parse,
      );
    },
    matterSyncV2: (orgFprint, matterId, location) => {
      const parse = true;
      return http.innerSendAuthenticated(
        {
          relativePath: `/clients/api/v2/org/${orgFprint}/clio/sync/matter/`,
          method: 'POST',
          headers: {
            Timezone: (-new Date().getTimezoneOffset()).toString(),
          },
          body: {
            external_id: matterId,
            ...(location && { location }),
          },
        },
        parse,
      );
    },
    bulkImport: (orgFprint) => {
      const parse = true;
      return http.innerSendAuthenticated(
        {
          relativePath: `/clients/api/v1/org/${orgFprint}/clio/bulk-import/`,
          method: 'POST',
        },
        parse,
      );
    },

    startEdit: (orgFprint, projectId, clioMatterId, destinationFolderId) => {
      const body = {
        clio_matter_id: clioMatterId,
        project_id: projectId,
      };

      // Add destination_folder_id only if provided (for new document sets)
      if (destinationFolderId) {
        body.destination_folder_id = destinationFolderId;
      }
      const parse = true;
      return http.innerSendAuthenticated(
        {
          relativePath: `/clients/api/v1/org/${orgFprint}/clio/edit/`,
          method: 'POST',
          body,
        },
        parse,
      );
    },

    startUpload: (orgFprint, projectId, clioMatterId) => {
      const body = {
        clio_matter_id: clioMatterId,
        project_id: projectId,
      };
      const parse = true;
      return http.innerSendAuthenticated(
        {
          relativePath: `/clients/api/v1/org/${orgFprint}/clio/upload/`,
          method: 'POST',
          body,
        },
        parse,
      );
    },

    uploadToS3: (documentVersion, documentBlob) => {
      const S3_UPLOAD_TIMEOUT_MS = 60000;
      const headers = Object.assign(
        {},
        ...documentVersion.put_headers.map((header) => ({
          [header.name]: header.value,
        })),
      );
      headers['Content-Length'] = documentBlob.size;

      const controller = new AbortController();
      const timeoutId = setTimeout(
        () => controller.abort(),
        S3_UPLOAD_TIMEOUT_MS,
      );

      return fetch(documentVersion.put_url, {
        body: documentBlob,
        method: 'PUT',
        headers,
        signal: controller.signal,
      }).finally(() => clearTimeout(timeoutId));
    },

    markFullyUploaded: (orgFprint, documents) => {
      const body = { documents };
      const parse = false;
      return http.innerSendAuthenticated(
        {
          relativePath: `/clients/api/v1/org/${orgFprint}/clio/upload/`,
          method: 'PATCH',
          body,
        },
        parse,
      );
    },
  };
}

export default authService();
